// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__355T9","title":"FrontImage_title__1X9SZ"};